<template>
  <NuxtLink
    class="flex flex-col items-center"
    :class="[ isActive ? 'text-primary' : 'text-secondary opacity-75' ]"
    :to="path"
  >
    <LayoutElementsIcon :name="item.icon || icons[item.id]" :solid="isActive" class="mb-1" />
    <span class="text-center text-[0.7rem] line-clamp-1 text-clip px-px">{{ item.name || item.icon }}</span>
  </NuxtLink>
</template>

<script setup lang="ts">
const route = useRoute()

interface Props {
  item: {
    id: keyof typeof paths
    name: string
    type: string
    slug: string
    icon: string
    information: string
  }
}

const props = defineProps<Props>()

const paths = {
  book: "/book-now",
  timetable: "/timetable",
  lastMinute: "/last-minute",
  giftCard: "/gift",
  pass: "/pass",
  gallery: "/gallery",
  review: "/reviews",
  user: "/customer"
}

const icons ={
  book: "clock",
  timetable: "calendar-days",
  lastMinute: "bell-alert",
  giftCard: "gift",
  pass: "ticket",
  gallery: "photo",
  review: "star",
  user: "user"
}

const path = computed(() => {
  if (props.item?.type === 'custom') {
    return `/page/${props.item?.slug}`
  }

  return paths[props.item?.id]
})

const isActive = computed(() => {
  return route.path.includes(path.value)
})
</script>
